import { Outlet } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Navbar from "../../utils/sidebarRes";
import "./index.css";
import HeaderDesk from "./headerDesk"
import { Visibility } from "@material-ui/icons";
import useWindowSize from "../../hooks/useWindowSize";

const Home = () => {

  const [navVisible, setNavVisible] = useState(false);
  const { width, height } = useWindowSize();
  // console.log("width",width);
//////
useEffect(() => {
  const handleResize = () => {
    const screenWidth = window.innerWidth;

    // Set state based on the screen width
    setNavVisible(screenWidth < 600);
  };

  // Initial call to set the initial state based on the screen width
  handleResize();

  // Add event listener for window resize
  window.addEventListener('resize', handleResize);

  // Clean up the event listener on component unmount
  return () => {
    window.removeEventListener('resize', handleResize);
  }; 

},[])


/////

  return (
    <>
      <div
       className="header_container"
      >
        <div
          className="header_item"
        >
        <HeaderDesk navVisible={navVisible} setNavVisible={setNavVisible}/>
        </div>
        <div
          className="nav_container"
          // style={navVisible?{}:{display: "none"}}
        >
          <div
            className="nav_item"
            style={navVisible?{display:"none"}:{}}
          >
            <Navbar show={setNavVisible} visible={navVisible} />
          </div>
          <div
            className="container_body"
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
